function Footer(): JSX.Element {
  return (
    <footer >
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-md text-textGray">
          <div className="flex items-center text-textGray gap-6">
            <a href="https://fincentive.co/#contact" className="hover:text-[#53978e] transition-colors duration-200 font-medium">
              Terms of Use
            </a>
            <a href="https://fincentive.co/#contact" className="hover:text-[#53978e] transition-colors duration-200 font-medium">
              Privacy Policy
            </a>
          </div>
          <div className=" font-medium">
            © Fincentive Technologies Pvt Ltd. 2024
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 